/**
 * Normalized browser consts
 */
export let BrowserName = /*#__PURE__*/function (BrowserName) {
  BrowserName["Edge"] = "Edge";
  BrowserName["LegacyEdge"] = "LegacyEdge";
  BrowserName["Chrome"] = "Chrome";
  BrowserName["Firefox"] = "Firefox";
  BrowserName["Safari"] = "Safari";
  BrowserName["Unknown"] = "Unknown";
  return BrowserName;
}({});

/**
 * Return normalized browser name from user agent string
 */
export function parseBrowserName(userAgent) {
  if (/Edg\/[\w\.]*/.test(userAgent)) {
    // NOTE: EDGE hijacks chrome and safari user agents, must be before them
    return BrowserName.Edge;
  } else if (/Edge\/[\w\.]*/.test(userAgent)) {
    // NOTE: EDGE hijacks chrome and safari user agents, must be before them
    return BrowserName.LegacyEdge;
  } else if (/Chrome\/[\w\.]*/.test(userAgent)) {
    // NOTE: chrome hijacks safari user agent, must be before safari
    return BrowserName.Chrome;
  } else if (/Firefox\/[\w\.]*/.test(userAgent)) {
    return BrowserName.Firefox;
  } else if (/Safari\/[\w\.]*/.test(userAgent)) {
    return BrowserName.Safari;
  }
  return BrowserName.Unknown;
}
let browserName = null;
/**
 * Returns current normalized user agent browser
 */
export function getBrowserName() {
  if (browserName === null) {
    browserName = parseBrowserName(window.navigator.userAgent);
  }
  return browserName;
}
//# sourceMappingURL=browser-name.js.map